import { useWatch } from "react-hook-form";

/**
 * Microcement Studio customization:
 * Shows an informational block with bathroom package pricing when the visitor
 * selects "Badkamer" or "Badkamer en woonvloer" in the "interesse" booking field.
 * Rendered inline under the select so users see it before continuing to submit.
 */
export function BadkamerInfoBlock() {
  const interesseValue = useWatch({ name: "responses.interesse" });

  // The value may be a string or { value, optionValue } depending on field shape.
  const rawValue =
    typeof interesseValue === "string"
      ? interesseValue
      : (interesseValue as { value?: string } | undefined)?.value;

  if (rawValue !== "badkamer" && rawValue !== "badkamer-en-woonvloer") {
    return null;
  }

  return (
    <div
      className="mt-3 rounded-lg border-l-4 p-5 text-sm"
      style={{ backgroundColor: "#f8f6f3", borderLeftColor: "#8d7b4b", color: "#090a0d" }}>
      <h4
        className="mb-3 text-base font-semibold"
        style={{ color: "#090a0d", fontFamily: "Bahnschrift, system-ui, sans-serif" }}>
        Belangrijk om te weten over badkamers
      </h4>
      <p className="mb-3 leading-relaxed">
        Indien u langs wilt komen voor een badkamer, willen wij u erop wijzen dat wij uitsluitend{" "}
        <strong>volledige badkamers</strong> aannemen. Dit betekent dat wij zowel de wanden als de vloer
        volledig verzorgen — losse vloeren of losse wanden kunnen wij helaas niet uitvoeren.
      </p>
      <p className="mb-3 leading-relaxed">
        Wij hanteren <strong>geen vierkante meterprijzen</strong>, omdat dit de kwaliteit van onze opbouw
        en gebruikte materialen niet recht doet. Daarom bieden wij heldere pakketprijzen:
      </p>
      <div className="my-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div className="rounded border p-3 text-center" style={{ backgroundColor: "#ffffff", borderColor: "#e6e2d8" }}>
          <div className="text-[11px] uppercase tracking-wide" style={{ color: "#706855" }}>
            Kleine badkamer
          </div>
          <div className="mt-1 text-base font-semibold" style={{ color: "#090a0d" }}>
            vanaf €12.000
          </div>
        </div>
        <div className="rounded border p-3 text-center" style={{ backgroundColor: "#ffffff", borderColor: "#e6e2d8" }}>
          <div className="text-[11px] uppercase tracking-wide" style={{ color: "#706855" }}>
            Gemiddelde badkamer
          </div>
          <div className="mt-1 text-base font-semibold" style={{ color: "#090a0d" }}>
            circa €14.000
          </div>
        </div>
        <div className="rounded border p-3 text-center" style={{ backgroundColor: "#ffffff", borderColor: "#e6e2d8" }}>
          <div className="text-[11px] uppercase tracking-wide" style={{ color: "#706855" }}>
            Grote badkamer
          </div>
          <div className="mt-1 text-base font-semibold" style={{ color: "#090a0d" }}>
            vanaf €15.000
          </div>
        </div>
      </div>
      <p className="mb-2 font-semibold">Onze pakketten bevatten:</p>
      <ul className="mb-3 list-none space-y-1 p-0">
        <li>✓ Cementgebonden stucwerk</li>
        <li>✓ Glasvezelnetten op alle oppervlakken tegen scheuren</li>
        <li>✓ Advies over de juiste drain</li>
        <li>
          ✓ Dekvloer afschot in de douche van epoxy mortel voor een waterdichte, krimpvrije verbinding
          naar de drain-aansluiting
        </li>
        <li>✓ Afwerking met Forcrete — het beste microcement ter wereld</li>
        <li>✓ Levenslange leveranciersgarantie van Forcrete op de waterdichtheid</li>
      </ul>
      <p className="mb-3 text-[13px] leading-relaxed" style={{ color: "#444" }}>
        Wij willen vooraf duidelijkheid over de kosten, omdat wij vaak zien dat een badkamer na een
        showroombezoek en offerte boven het budget van de klant uitkomt. Zo voorkomen wij teleurstellingen
        en besparen wij tijd voor beide partijen.
      </p>
      <p className="font-semibold">
        Nog steeds geïnteresseerd? Uiteraard bent u van harte welkom in onze showroom om alles van dichtbij
        te bekijken.
      </p>
    </div>
  );
}
